module.exports = __webpack_public_path__ + "static/media/user.7d8a01fa.png";